import { Directionality } from "@angular/cdk/bidi";
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef, NgZone, OnInit, Optional, Renderer2 } from "@angular/core";
import { NzConfigService } from "ng-zorro-antd/core/config";
import { fromEvent, takeUntil } from "rxjs";
import { DestroyService } from "@webapp/core/util/services/destroy.service";
import { UiButtonComponent } from "@webapp/ui/button/button.component";
import { UiButtonModule } from "@webapp/ui/button/button.module";

const ACTION_KEYS = [" ", "Enter"];

/**
 * This should only be used in Angular.js
 */
@Component({
  selector: "ui-button",
  providers: [DestroyService],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `<ng-content></ng-content>`,
  preserveWhitespaces: false,
  standalone: true,
  imports: [UiButtonModule],
  host: {
    role: "button",
  },
})
export class ButtonComponent extends UiButtonComponent implements OnInit {
  constructor(
    private thisNgZone: NgZone,
    elementRef: ElementRef<HTMLElement>,
    cdr: ChangeDetectorRef,
    thisRenderer: Renderer2,
    nzConfigService: NzConfigService,
    private destroyService$: DestroyService,
    @Optional() directionality: Directionality
  ) {
    super(thisNgZone, elementRef, cdr, thisRenderer, nzConfigService, directionality);
  }

  public ngOnInit(): void {
    super.ngOnInit();

    const { nativeElement } = this.thisElementRef;

    this.thisNgZone.runOutsideAngular(() => {
      fromEvent<MouseEvent>(nativeElement, "click", { capture: true })
        .pipe(takeUntil(this.destroyService$))
        .subscribe((event) => {
          if (this.disabled) {
            event.preventDefault();
            event.stopImmediatePropagation();
          }
        });

      fromEvent<KeyboardEvent>(nativeElement, "keypress", { capture: true })
        .pipe(takeUntil(this.destroyService$))
        .subscribe((event) => {
          if (ACTION_KEYS.includes(event.key)) {
            event.preventDefault();
            this.thisNgZone.run(() => nativeElement.click());
          }
        });
    });
  }
}
